import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  NgModule,
} from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { PageTabRouteComponent } from './page-tab-route.component';
import { MatTabScrollToCenterDirective } from './directives/mat-tab-scroll-to-center.directive';
import { ScrollRestoreMangerDirective } from './directives/scroll-restore-manger.directive';
import { ScrollableContainerDirective } from './directives/scrollable-container.directive';

@NgModule({
  imports: [CommonModule, MatTabsModule, RouterModule],
  declarations: [
    PageTabRouteComponent,
    MatTabScrollToCenterDirective,
    ScrollRestoreMangerDirective,
    ScrollableContainerDirective,
  ],
  exports: [
    PageTabRouteComponent,
    MatTabScrollToCenterDirective,
    ScrollRestoreMangerDirective,
    ScrollableContainerDirective,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class PageTabRouteModule {}
